import script from "./PatchingSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./PatchingSidebar.vue?vue&type=script&setup=true&lang=js"

import "./PatchingSidebar.vue?vue&type=style&index=0&id=62df82fe&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ELA/ELA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62df82fe"]])

export default __exports__